import { RBHBox, RBHButton, RBHImage, RBHRadio, RBHSelect, RBHText, RBHTextInput } from '..';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Divider, Form, Modal, Radio, Row, Select, Space, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { generalCreators } from '../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../redux/general/general-constant';
import { GENERAL_STATE_KEY, generalStateSelector, MODAL } from '../../../redux/general/general-reducer';
import { Fonts, Images } from '../../theme';
import metrics from '../../theme/metrics';
import styleButton from '../rbh-button/styles';
import styleText from '../rbh-text/styles';
import styles from './styles';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { UtilHelper } from '../../helpers/utility';
import { POS_REQUEST_ID_LIST } from '../../../main/Screen/BranchManagement/PosManagement/redux/pos-constant';
import { posSagas } from '../../../main/Screen/BranchManagement/PosManagement/redux/pos-saga';
import { PosService } from '../../../main/Screen/BranchManagement/PosManagement/redux/pos-service';
import { posCreators } from '../../../main/Screen/BranchManagement/PosManagement/redux/pos-action';
import { POS_STATE_KEY } from '../../../main/Screen/BranchManagement/PosManagement/redux/pos-reducer';
import { branchCreators } from '../../../main/Screen/BranchManagement/redux/branch-action';
import { REPORT_REQUEST_ID_LIST } from '../../../main/Screen/Report/redux/report-constant';
import { ReportService } from '../../../main/Screen/Report/redux/report-service';
import { reportSagas } from '../../../main/Screen/Report/redux/report-saga';
import { reportCreators } from '../../../main/Screen/Report/redux/report-action';
import { REPORT_ALERT, REPORT_STATE_KEY, reportStateSelector } from '../../../main/Screen/Report/redux/report-reducer';
import commonStyle from '../../theme/common-style';
import { martProductStateSelector, MART_PRODUCT_STATE_KEY } from '../../../main/Screen/MartProduct/redux/martProduct-reducer';
import './style.css';
import { MART_PRODUCT_REQUEST_ID_LIST, PRODUCT_WEIGHT_UNIT } from '../../../main/Screen/MartProduct/redux/martProduct-constant';
import { MartProductService } from '../../../main/Screen/MartProduct/redux/martProduct-service';
import { martProductSagas } from '../../../main/Screen/MartProduct/redux/martProduct-saga';
import { martProductCreators } from '../../../main/Screen/MartProduct/redux/martProduct-action';
import numeral from 'numeral';
import { WarningFilled } from '@ant-design/icons';


export const RBHModal = (props: any) => {
  const [form] = Form.useForm();
  const modal = useSelector(generalStateSelector(GENERAL_STATE_KEY.MODAL)) as MODAL;
  const dispatch = useDispatch();
  const [hover, setHover] = useState<boolean>(false);
  const reportTypeSelected = useSelector(reportStateSelector(REPORT_STATE_KEY.REPORT_TYPE_SELECTED));
  const [formInvalid, setFormInvalid] = useState(true);
  const productWeightUnitList = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_UNIT)) as any;
  const weightGram = productWeightUnitList?.find((value: any) => value.productWeightUnitId === PRODUCT_WEIGHT_UNIT.GRAM);
  const weightKilogram = productWeightUnitList?.find((value: any) => value.productWeightUnitId === PRODUCT_WEIGHT_UNIT.KILOGRAM);
  const weightMilliLiter = productWeightUnitList?.find((value: any) => value.productWeightUnitId === PRODUCT_WEIGHT_UNIT.MILLILITER);
  const weightLiter = productWeightUnitList?.find((value: any) => value.productWeightUnitId === PRODUCT_WEIGHT_UNIT.LITER);
  const productSizeList = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.PRODUCT_SIZE)) as any;
  const productAmountConfig = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.PRODUCT_AMOUNT_CONFIG)) as any;
  const isEditBasketLimit = useSelector(martProductStateSelector(MART_PRODUCT_STATE_KEY.IS_EDIT_BASKET_LIMIT));
  const [piecesPerPackRadioValue, setPiecesPerPackRadioValue] = useState(
    modal?.piecesPerPackOption ? modal?.piecesPerPackOption === 1 ? 1 : 2 : 1);
  const [weightSizeLimitRadioValue, setWeightSizeLimitRadioValue] = useState(
    modal ? !!modal?.weightLimitSelect ? 1 : !!modal?.sizeLimitSelect ? 2 : 1 : 1);
    const lang = useSelector(generalStateSelector(GENERAL_STATE_KEY.LOCALE));
    

  useEffect(() => {
    if (modal.type === MODAL_TYPE.PRODUCT_LIMIT) {
      if (modal.visible) {
        form.resetFields();
        form.setFieldsValue({
          weightLimitSelect: modal?.weightUnitId ? modal?.weightUnitId : 1,
          sizeLimitSelect: modal?.sizeLimitId ? modal?.sizeLimitId : 1
        });
        if (!isEditBasketLimit) {
          resetFormProductDetail();
        }
        form.validateFields();
      }
    }
  }, [modal.visible]);

  useEffect(() => {
    if (modal.type === MODAL_TYPE.PRODUCT_LIMIT) {
      setPiecesPerPackRadioValue(modal?.piecesPerPackOption ? modal?.piecesPerPackOption === 1 ? 1 : 2 : 1);
    }
  }, [modal.visible, modal?.piecesPerPackOption]);

  useEffect(() => {
    if (modal.type === MODAL_TYPE.PRODUCT_LIMIT) {
      setWeightSizeLimitRadioValue(!!modal?.weightLimitSelect ? 1 : !!modal?.sizeLimitSelect ? 2 : 1);
    }
  }, [modal.visible, modal?.weightLimitSelect]);

  const onCancel = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: false,
      onOk: null,
      type: modal.type
    }));
  };

  const resetCallBranch = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(branchCreators.callBranch());
  };

  const deactivatePos = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImageId: 'deactivatePos-alert-img',
      modalTitle: 'main.posManagement.posActivate.popup.deactivatePos.header',
      modalTitleId: 'deactivatePos-header-text',
      modalContent: 'main.posManagement.posActivate.popup.deactivatePos.content',
      modalContentId: 'deactivatePos-content-text',
      onOkText: 'main.posManagement.posActivate.popup.deactivatePos.ok',
      onOkTextId: 'deactivatePos-ok-text',
      onCancelText: 'main.posManagement.posActivate.popup.deactivatePos.cancel',
      onCancelTextId: 'deactivatePos-cancel-text',
      onCancel: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
          visible: true,
          modalListContent: modal.modalListContent,
          type: MODAL_TYPE.POS_DETAIL
        }));
      },
      onConfirm: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
        dispatch(httpCreators.request({
          id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS,
          sagaHandler: posSagas.patchCancelPosHandler as any,
          service: PosService.patchCancelPos,
          serviceParams: { shopId: modal.modalListContent.shopId },
          callbackParams: {
            alertDeactivatePosSuccess: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS, true)),
            alertDeactivatePosFail: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL, true)),
            resetCallBranch
          },
        }));
      },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const onOk = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: false,
      onOk: null,
      type: modal.type,
      modalTitle: modal.modalTitle,
      modalContent: modal.modalContent
    }));
    modal.onOk && modal.onOk();
    if (modal.type === MODAL_TYPE.CONFIRM_EDIT) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const onMouseOver = () => {
    setHover(!hover);
  };

  const onCancelPickReport = () => {
    if (modal.type === MODAL_TYPE.PICK_REPORT) {
      onCancel();
      form.setFieldsValue({ reportType: reportTypeSelected });
    }
  };

  const alertReportTypeFail = () => {
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_COUNTDOWN, true));
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.ALERT_STATE, REPORT_ALERT.ALERT_REPORT_TYPE_FAIL));
  };

  const batchError = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.report.pickReport.popup.content.batchError',
      modalContentId: 'pickReportType-batchTimeError',
      values: { batchReportStart: modal.batchReportStart, batchReportEnd: modal.batchReportEnd },
      onOk: () => { alertReportTypeFail(); },
      type: MODAL_TYPE.ERROR
    }));
  };

  const onFinishPickReport = (value: any) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false, }));
    const data = { type: Number(value.reportType) };
    dispatch(reportCreators.setReportState(REPORT_STATE_KEY.REPORT_TYPE_SELECTED, data.type));
    form.setFieldsValue({ reportType: data.type });
    dispatch(httpCreators.request({
      id: REPORT_REQUEST_ID_LIST.PATCH_REPORT_TYPE,
      sagaHandler: reportSagas.patchPickEmailTypeHandler as any,
      callbackParams: { batchError, alertReportTypeFail },
      service: ReportService.patchReportType,
      serviceParams: data
    }));
  };

  const resetFormProductDetail = () => {
    form.resetFields();
    form.setFieldsValue({
      piecesPerPackOption: 1,
      weightSizeLimitOption: 1
    });
    formSetFieldsError(['weightLimitOption1Input', 'piecesPerPackOption2Input'], []);
    setPiecesPerPackRadioValue(1);
    setWeightSizeLimitRadioValue(1);
  };

  const onChangePiecesPerPackRadio = (e: any) => {
    setPiecesPerPackRadioValue(e.target.value);
  };

  const onChangeWeightSizeLimitRadio = (e: any) => {
    setWeightSizeLimitRadioValue(e.target.value);
  };

  const clearDecimal = (fieldName: string) => {
    const value = Number(form.getFieldValue(fieldName));
    if (value < 0 || value) {
      if (fieldName === 'piecesPerPackOption2Input') {
        let piecesPerPackOption2Input = String(value);
        if (piecesPerPackOption2Input.indexOf('.') > -1) {
          const arr = piecesPerPackOption2Input.split('.');
          piecesPerPackOption2Input = arr[0];
        }
        form.setFieldsValue({
          [fieldName]: Number(piecesPerPackOption2Input)
        });
      } else {
        let weightLimitOption1Input = String(value);
        if (weightLimitOption1Input.indexOf('.') > -1) {
          const arr = weightLimitOption1Input.split('.');
          if (arr[1].length > 2) {
            weightLimitOption1Input = arr[0] + '.' + arr[1].substring(0, 2);
          }
        }
        form.setFieldsValue({
          [fieldName]: Number(weightLimitOption1Input)
        });
      }
    }
    form.validateFields([fieldName]);
  };

  const { Option } = Select;
  const selectWeightLimit = () => {
    return productWeightUnitList.map((result: any, index: number) => {
      return (
        <Option
          key={index}
          id={`weightLimitSelect-${index}`}
          data-testid={`weightLimitSelect-${index}`}
          value={result.productWeightUnitId}
          style={styleText.formText}
          title={result.productWeightUnitNameTh}
        >
          {result.productWeightUnitNameTh}
        </Option>
      );
    });
  };

  const getSelectWeightLimit = () => {
    return (
      <Form.Item noStyle name={'weightLimitSelect'} colon={false} validateTrigger={['onChange', 'onBlur']}
        initialValue={modal?.weightUnitId ? modal?.weightUnitId : 1}>
        <RBHSelect id={'weightLimitSelect'} data-testid={'weightLimitSelect'} name={'weightLimitSelect'}
          style={styles.getSelectWeightLimit}
        >
          {selectWeightLimit()}
        </RBHSelect>
      </Form.Item>
    );
  };

  const selectproductSize = () => {
    return productSizeList.map((result: any, index: number) => {
      return (
        <Option
          key={index}
          id={`sizeLimitSelect-${index}`}
          data-testid={`sizeLimitSelect-${index}`}
          value={result.productSizeId}
          style={styleText.formText}
          title={result.productSizeNameTh}
        >
          {result.productSizeNameTh}
        </Option>
      );
    });
  };

  const formSetFieldsError = (fieldName: string[], errorShow: string[]) => {
    form.setFields([{
      name: fieldName,
      errors: errorShow
    }]);
    setFormInvalid(true);
  };

  const checkFormProductLimitInvalid = () => {
    const productAmountMin = Number(productAmountConfig?.productAmountMin);
    const productAmountMax = Number(productAmountConfig?.productAmountMax);
    let invalid = false;
    const values = form.getFieldsValue();

    if (!!values.piecesPerPackOption2Input) {
      if (!isNaN(values.piecesPerPackOption2Input)) {
        if (values.piecesPerPackOption2Input < productAmountMin || values.piecesPerPackOption2Input > productAmountMax) {
          formSetFieldsError(['piecesPerPackOption2Input'],
            [`ต้องเป็นตัวเลขระหว่าง ${productAmountMin} ถึง ${numeral(productAmountMax).format('0,0')}`]);
        }
      } else {
        formSetFieldsError(['piecesPerPackOption2Input'],
          [`ต้องเป็นตัวเลขระหว่าง ${productAmountMin} ถึง ${numeral(productAmountMax).format('0,0')}`]);
      }
    }

    switch (values.weightLimitSelect) {
      case PRODUCT_WEIGHT_UNIT.GRAM:
        if (values.weightLimitOption1Input) {
          if (!isNaN(values.weightLimitOption1Input)) {
            if (values.weightLimitOption1Input < weightGram.productWeightUnitMin
              || values.weightLimitOption1Input > weightGram.productWeightUnitMax) {
              formSetFieldsError(['weightLimitOption1Input'],
                [`ต้องเป็นตัวเลขระหว่าง ${weightGram.productWeightUnitMin} ถึง ${numeral(weightGram.productWeightUnitMax).format('0,0')}`]);
            } else {
              formSetFieldsError(['weightLimitOption1Input'], []);
            }
          } else {
            formSetFieldsError(['weightLimitOption1Input'],
              [`ต้องเป็นตัวเลขระหว่าง ${weightGram.productWeightUnitMin} ถึง ${numeral(weightGram.productWeightUnitMax).format('0,0')}`]);
          }
        }
        break;

      case PRODUCT_WEIGHT_UNIT.KILOGRAM:
        if (values.weightLimitOption1Input) {
          if (!isNaN(values.weightLimitOption1Input)) {
            if (values.weightLimitOption1Input < weightKilogram.productWeightUnitMin
              || values.weightLimitOption1Input > weightKilogram.productWeightUnitMax) {
              formSetFieldsError(['weightLimitOption1Input'],
                [`ต้องเป็นตัวเลขระหว่าง ${weightKilogram.productWeightUnitMin} ถึง ${numeral(weightKilogram.productWeightUnitMax).format('0,0')}`]);
            } else {
              formSetFieldsError(['weightLimitOption1Input'], []);
            }
          } else {
            formSetFieldsError(['weightLimitOption1Input'],
              [`ต้องเป็นตัวเลขระหว่าง ${weightKilogram.productWeightUnitMin} ถึง ${numeral(weightKilogram.productWeightUnitMax).format('0,0')}`]);
          }
        }
        break;

      case PRODUCT_WEIGHT_UNIT.MILLILITER:
        if (values.weightLimitOption1Input) {
          if (!isNaN(values.weightLimitOption1Input)) {
            if (values.weightLimitOption1Input < weightMilliLiter.productWeightUnitMin
              || values.weightLimitOption1Input > weightMilliLiter.productWeightUnitMax) {
              formSetFieldsError(['weightLimitOption1Input'],
                [`ต้องเป็นตัวเลขระหว่าง ${weightMilliLiter.productWeightUnitMin} 
                ถึง ${numeral(weightMilliLiter.productWeightUnitMax).format('0,0')}`]);
            } else {
              formSetFieldsError(['weightLimitOption1Input'], []);
            }
          } else {
            formSetFieldsError(['weightLimitOption1Input'],
              [`ต้องเป็นตัวเลขระหว่าง ${weightMilliLiter.productWeightUnitMin} ถึง ${numeral(weightMilliLiter.productWeightUnitMax).format('0,0')}`]);
          }
        }
        break;

      default:
        // PRODUCT_WEIGHT_UNIT.LITER
        if (values.weightLimitOption1Input) {
          if (!isNaN(values.weightLimitOption1Input)) {
            if (values.weightLimitOption1Input < weightLiter.productWeightUnitMin
              || values.weightLimitOption1Input > weightLiter.productWeightUnitMax) {
              formSetFieldsError(['weightLimitOption1Input'],
                [`ต้องเป็นตัวเลขระหว่าง ${weightLiter.productWeightUnitMin} ถึง ${numeral(weightLiter.productWeightUnitMax).format('0,0')}`]);
            } else {
              formSetFieldsError(['weightLimitOption1Input'], []);
            }
          } else {
            formSetFieldsError(['weightLimitOption1Input'],
              [`ต้องเป็นตัวเลขระหว่าง ${weightLiter.productWeightUnitMin} ถึง ${numeral(weightLiter.productWeightUnitMax).format('0,0')}`]);
          }
        }
        break;
    }

    for (const key in values) {
      if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }

    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const onFinishWeightSizeLimit = (value: any) => {
    dispatch(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_WEIGHT, undefined));
    dispatch(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_SIZE, undefined));
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
    const data = {
      productWeightProduct: value.weightSizeLimitOption === 2 ? null : {
        productWeightValue: value.weightLimitOption1Input,
        productWeightUnitId: value.weightLimitSelect
      },
      productSizeProduct: value.weightSizeLimitOption === 1 ? null : {
        productSizeId: value.sizeLimitSelect
      },
      productPerpackProduct: {
        productPerpackAmount: value.piecesPerPackOption2Input || 1
      }
    };
    dispatch(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_SIZE_DATA, data));
    let dataLimitWeight;
    let dataLimitSize;
    if (value.weightSizeLimitOption === 1) {
      dataLimitWeight = {
        productPerpackAmount: value.piecesPerPackOption2Input || 1,
        productWeightValue: value.weightLimitOption1Input,
        productWeightUnitId: value.weightLimitSelect
      };
    } else {
      dataLimitSize = {
        productPerpackAmount: value.piecesPerPackOption2Input || 1,
        productSizeId: value.sizeLimitSelect
      };
    }
    dispatch(httpCreators.request({
      sagaHandler: value.weightSizeLimitOption === 1
        ? martProductSagas.postCalculateProductOrderLimitWeightHandler as any
        : martProductSagas.postCalculateProductOrderLimitSizeHandler as any,
      id: value.weightSizeLimitOption === 1
        ? MART_PRODUCT_REQUEST_ID_LIST.POST_CALCULATE_PRODUCT_ORDER_LIMIT_WEIGHT
        : MART_PRODUCT_REQUEST_ID_LIST.POST_CALCULATE_PRODUCT_ORDER_LIMIT_SIZE,
      service: value.weightSizeLimitOption === 1
        ? MartProductService.postCalculateProductOrderLimitWeight
        : MartProductService.postCalculateProductOrderLimitSize,
      serviceParams: value.weightSizeLimitOption === 1
        ? dataLimitWeight
        : dataLimitSize
    }));
  };

  const onCancelproductLimit = () => {
    onCancel();
    if (!isEditBasketLimit) {
      resetFormProductDetail();
    }
    modal.afterClose();
  };

  const onAfterClose = () => {
    if (modal.type === MODAL_TYPE.PRODUCT_LIMIT) {
      form.resetFields();
    }
  };

  const showModal = () => {
    if (modal.type === MODAL_TYPE.CONFIRM_EDIT) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            <RBHImage src={modal.modalImage || Images.alert} data-testid={modal.modalImageId || 'confirm-edit-img-alert'}
              id={modal.modalImageId || 'confirm-edit-img-alert'} />
          </Row>
          <br />
          <RBHText
            style={styleText.textModalHeader}
            data-testid={modal.modalTitleId || 'confirm_edit_header'}
            id={modal.modalTitleId || 'confirm_edit_header'}
            text={modal.modalTitle || 'main.confirm_edit_header'}
          />
          {modal.values && (
            <RBHText
              style={styleText.textModalHeader}
              data-testid={modal.valueId}
              id={modal.valueId}
              text={modal.valueText}
              values={modal.values}
            />
          )
          }
          <RBHText
            style={styleText.textModalContent}
            data-testid={modal.modalContentId || 'confirm_edit_content'}
            id={modal.modalContentId || 'confirm_edit_content'}
            text={modal.modalContent || 'main.confirm_edit_content'}
            values={modal.valuesContent}
          />
          <br />
          <Row justify={'center'} align={'middle'}>
            <Space size={'middle'}>
              <RBHButton
                style={styleButton.buttonModalCancelGradient}
                id={modal.onCancelTextId || 'button_cancel'}
                key={'back'}
                onClick={modal.onCancel || onCancel}
                data-testid={modal.onCancelTextId || 'popupConfirmEditButtonCancel'}>
                <FormattedMessage id={modal.onCancelText || 'main.button_cancel'} />
              </RBHButton>
              <RBHButton
                style={styleButton.buttonModalConfirmGradient}
                id={modal.onOkTextId || 'button_confirm'}
                key={'submit'}
                type={'primary'}
                onClick={modal.onConfirm || onOk}
                data-testid={modal.onOkTextId || 'popupConfirmEditButtonConfirm'}>
                <FormattedMessage id={modal.onOkText || 'main.button_confirm'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.DELETE) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            <RBHImage src={Images.alert} data-testid={'confirm-delete-img-alert'} id={'confirm-delete-img-alert'} />
          </Row>
          <br />
          <RBHText style={styleText.textModalHeader} id={'deleteTitle'} text={modal.modalTitle} />
          <RBHText style={styleText.textModalContent} id={'deleteContent'} text={modal.modalContent} />
          <br />
          <Row justify='center' align='middle'>
            <Space size={'middle'}>
              <RBHButton style={styleButton.buttonModalCancelGradient} data-testid={'button_cancel'}
                id={'button_cancel'} key='back' onClick={onCancel}>
                <FormattedMessage id={'main.button_cancel'} />
              </RBHButton>
              <RBHButton style={styleButton.buttonModalConfirmGradient} data-testid={'button_confirm'}
                id={'button_confirm'} key='submit' type='primary' onClick={onOk}>
                <FormattedMessage id={'main.button_confirm'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.ERROR) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            {modal.modalIcon ? modal.modalIcon :
              <RBHImage src={modal.modalImage || Images.alert} data-testid={modal.modalImageId || 'error-img-alert'}
                id={modal.modalImageId || 'error-img-alert'} />
            }
          </Row>
          <br />
          <RBHText style={styleText.textModalHeader} data-testid={modal.modalTitleId || 'notavailable'}
            id={modal.modalTitleId || 'notavailable'} text={modal.modalTitle || 'main.notavailable'} />
          {modal.values ?
            <RBHText style={styleText.textModalContent} data-testid={modal.modalContentId || 'retry'}
              id={modal.modalContentId || 'retry'} text={modal.modalContent || 'main.retry'} values={modal.values} />
            :
            <RBHText style={styleText.textModalContent} data-testid={modal.modalContentId || 'retry'}
              id={modal.modalContentId || 'retry'} text={modal.modalContent || 'main.retry'} />
          }
          <br />
          <Row justify='center' align='middle'>
            <Space size={'middle'}>
              <RBHButton style={styleButton.buttonModalConfirmGradient} data-testid={modal.onOkTextId || 'button_ok'}
                id={modal.onOkTextId || 'button_ok'} key='submit' type='primary' onClick={onOk}>
                <FormattedMessage id={modal.onOkText || 'main.button_ok'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.SUCCESS) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}><CheckCircleOutlined id={'indexIdIcon'} translate={null} style={styles.successIcon} /></Row>
          <br />
          <RBHText style={styleText.textModalHeader} id={'successTitle'} text={modal.modalTitle} />
          <RBHText style={styleText.textModalContent} id={'successContent'} text={modal.modalContent} />
          <br />
          <Row justify='center' align='middle'>
            <Space size={'middle'}>
              <RBHButton style={styleButton.buttonModalConfirmGradient} id={'button_ok'} key='submit' type='primary' onClick={onOk}>
                <FormattedMessage id={'main.button_ok'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.BLANK) {
      return (
        null
      );
    } else if (modal.type === MODAL_TYPE.LIST_VIEW) {
      return (
        <RBHBox style={styles.listViewContainer}>
          <RBHBox style={styles.listViewHeader}>
            <Row justify={'space-between'} align='middle'>
              <RBHText id={'list_view_title'}
                style={styles.listViewHeaderText}
                text={modal.modalTitle} />
              <RBHImage id={'close_button'} src={Images.close} style={{ width: '24px', cursor: 'pointer' }} onClick={onCancel} />
            </Row>
            <RBHBox onMouseOver={onMouseOver} onMouseOut={onMouseOver}>
              <RBHText id={'list_view_subtitle'} style={styles.listViewSubtitleText}>
                {modal.modalContent}
              </RBHText>
            </RBHBox>
            {hover && <RBHBox>
              <RBHBox style={styles.popoverTriangle} />
              <RBHBox id={'popover_content'} style={styles.popoverContainer}>
                {modal.modalContent}
              </RBHBox>
            </RBHBox>}
          </RBHBox>
          <RBHBox style={styles.line} />
          <RBHBox style={styles.listViewContent} id={'list_view_content'}>
            {modal?.modalListContent?.map((item: any, index: number) => {
              const testIndex = index + 1;
              return (<RBHBox key={index} style={{ marginBottom: index + 1 === modal?.modalListContent.length ? 0 : metrics.baseMargin }}>
                <Row>
                  <RBHBox style={{ width: metrics.base * 3 }}>
                    <RBHText style={Fonts.style.textBodyRegularFakeBlack14} id={'index_' + testIndex}>{`${testIndex}.`}</RBHText>
                  </RBHBox>
                  <RBHBox style={{ width: metrics.base * 52.8 }}>
                    <RBHText style={Fonts.style.textBodyRegularFakeBlack14} id={'shop_name_' + testIndex}>{item.shopName}</RBHText>
                    <RBHText style={Fonts.style.textBodyRegularGray12} id={'branch_code_' + testIndex}>
                      {!!item.branchCode ? item.branchCode : ''}</RBHText>
                  </RBHBox>
                </Row>
              </RBHBox>
              );
            })}
          </RBHBox>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.POS_LEAVE_STEP_CONFIRM) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            <RBHImage src={modal.modalImage || Images.alert}
              data-testid={modal.modalImageId || 'pos-leaveConfirm-img-alert'}
              id={modal.modalImageId || 'pos-leaveConfirm-img-alert'} />
          </Row>
          <br />
          <RBHText style={styleText.textModalHeader} data-testid={modal.modalTitleId || 'pos-leaveConfirm-header'}
            id={modal.modalTitleId || 'pos-leaveConfirm-header'}
            text={'main.posManagement.posActivate.popup.leaveConfirm.header'} />
          <RBHText style={styleText.textModalContent} data-testid={modal.modalContentId || 'pos-leaveConfirm-content'}
            id={modal.modalContentId || 'pos-leaveConfirm-content'} text={'main.posManagement.posActivate.popup.leaveConfirm.content'} />
          <Row justify='center' align='middle'>
            <RBHButton style={styles.posSaveAndLeave} id={'pos-popup-saveAndLeave-btn'} key='back'
              onClick={modal.onSaveAndLeave} data-testid={'pos-popup-saveAndLeave-btn'}>
              <FormattedMessage id={'main.posManagement.posActivate.popup.leaveConfirm.button.saveAndLeave'} />
            </RBHButton>
            <RBHButton style={styles.posLeaveOnly} id={'pos-popup-leaveOnly-btn'} key='submit'
              type='primary' onClick={modal.onLeaveOnly} data-testid={'pos-popup-leaveOnly-btn'}>
              <FormattedMessage id={'main.posManagement.posActivate.popup.leaveConfirm.button.leaveOnly'} />
            </RBHButton>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.POS_NO_FOOD_FOUND) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            <RBHImage src={Images.alert} data-testid={'pos-noFoodFound-img-alert'} id={'pos-noFoodFound-img-alert'} />
          </Row>
          <br />
          <RBHText style={styleText.textModalHeader} id={'pos-noFoodFound-header'}
            text={'main.posManagement.posActivate.popup.noFoodFound.header'} />
          <RBHText style={styleText.textModalContent} id={'pos-noFoodFound-content'}
            text={'main.posManagement.posActivate.popup.noFoodFound.content'} />
          <br />
          <Row justify='center' align='middle'>
            <Space size={'middle'}>
              <RBHButton style={styles.posNoFoodFoundCancel} id={'pos-popup-cancel-btn'} key='back'
                onClick={() => {
                  onCancel();
                  modal.onCancel && modal.onCancel();
                }} data-testid={'pos-popup-cancel-btn'}>
                <FormattedMessage id={'main.posManagement.posActivate.popup.noFoodFound.button.cancel'} />
              </RBHButton>
              <RBHButton style={styles.posNoFoodFoundToFoodMenu} id={'pos-popup-toFoodMenu-btn'} key='submit'
                type='primary' onClick={onOk} data-testid={'pos-popup-toFoodMenu-btn'}>
                <FormattedMessage id={'main.posManagement.posActivate.popup.noFoodFound.button.toFoodMenu'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.POS_DETAIL && modal.modalListContent) {
      return (
        <RBHBox style={styles.posDetailBox}>
          <RBHBox style={{ padding: '20px 23px 20px 20px' }}>
            <Row justify={'space-between'} align='middle'>
              <RBHText style={styles.posDetailHeaderText} data-testid={'posDetailHeader'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.header'} />
              <RBHImage id={'close_button'} src={Images.close} style={{ width: '24px', cursor: 'pointer' }} onClick={onCancel} />
            </Row>
          </RBHBox>
          <RBHBox style={styles.line} />
          <RBHBox style={{ padding: '20px 20px 24px 20px' }}>
            <Space size={52} style={{ paddingBottom: '16px' }}>
              <RBHText style={styles.posDetailLabelText} data-testid={'shopNameLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label1'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {modal.modalListContent.shopName}
              </RBHText>
            </Space><br />
            <Space size={79} style={{ paddingBottom: '16px' }}>
              <RBHText style={styles.posDetailLabelText} data-testid={'shopIdLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label2'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {modal.modalListContent.shopId}
              </RBHText>
            </Space><br />
            <Space size={48} style={{ paddingBottom: '16px' }}>
              <RBHText style={styles.posDetailLabelText} data-testid={'branchCodeLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label3'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {modal.modalListContent.branchCode}
              </RBHText>
            </Space><br />
            <Space size={52} style={{ paddingBottom: '16px' }}>
              <RBHText style={styles.posDetailLabelText} data-testid={'providerNameLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label4'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {modal.modalListContent.provider.providerName}
              </RBHText>
            </Space><br />
            <Space size={49} style={{ paddingBottom: '16px' }}>
              <RBHText style={styles.posDetailLabelText} data-testid={'posReferenceIdLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label5'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {modal.modalListContent.posReferenceId}
              </RBHText>
            </Space><br />
            <Space size={61}>
              <RBHText style={styles.posDetailLabelText} data-testid={'posStartDateLabel'} id={'pos-noFoodFound-content'}
                text={'main.posManagement.landing.popup.posDetail.label6'} />
              <RBHText style={styles.posDetailDataText} id={'pos-noFoodFound-content'}>
                {UtilHelper.formatFullDate(modal.modalListContent.posStartDate, lang)}
              </RBHText>
            </Space>
          </RBHBox>
          <RBHBox style={styles.line} />
          <RBHBox style={{ padding: '15px 20px 15px 20px' }}>
            <Row justify={'space-between'} align='middle'>
              <Tag id={'pos-popupDetail-activate-tag'} data-testid={'posPopupDetailActivateTag'} style={styles.tagPs03noDate}>
                <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps03.noDate'} />
              </Tag>
              <RBHText data-testid={'cancelPosActivatePopupDetail'} id={'cancel-posActivate-popupDetail'}
                style={styles.regularPurple14under} text={'main.posManagement.posActivate.cancelPos'}
                onClick={deactivatePos} />
            </Row>
          </RBHBox>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.BACK_TO_PREVIOUS) {
      return (
        <RBHBox style={styles.default}>
          <Row align={'middle'} justify={'center'}>
            <RBHImage src={modal.modalImage || Images.alert} data-testid={modal.modalImageId || 'backToPrevious-img-alert'}
              id={modal.modalImageId || 'backToPrevious-img-alert'} />
          </Row>
          <br />
          <RBHText style={styleText.textModalHeader} id={modal.modalTitleId || 'backToPrevious-header'}
            data-testid={modal.modalTitleId || 'backToPrevious-header'}
            text={modal.modalTitle || 'main.posManagement.posActivate.popup.backToPrevious.header'} />
          <RBHText style={styleText.textModalContent} id={modal.modalContentId || 'backToPrevious-content'}
            data-testid={modal.modalContentId || 'backToPrevious-content'}
            text={modal.modalContent || 'main.posManagement.posActivate.popup.backToPrevious.content'} />
          <br />
          <Row justify='center' align='middle'>
            <Space size={'middle'}>
              <RBHButton style={styleButton.buttonModalCancelGradient} id={modal.onCancelTextId || 'backToPrevious-cancelBtn'} key='back'
                onClick={modal.onCancel || onCancel} data-testid={modal.onCancelTextId || 'backToPrevious-cancelBtn'}>
                <FormattedMessage id={modal.onCancelText || 'main.posManagement.posActivate.popup.backToPrevious.onCancel'} />
              </RBHButton>
              <RBHButton style={styleButton.buttonModalConfirmGradient} id={modal.onOkTextId || 'backToPrevious-okBtn'} key='submit'
                type='primary' onClick={modal.onOk || onOk} data-testid={modal.onOkTextId || 'backToPrevious-okBtn'}>
                <FormattedMessage id={modal.onOkText || 'main.posManagement.posActivate.popup.backToPrevious.onOk'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.PICK_REPORT) {
      return (
        <RBHBox style={styles.pickReportBox}>
          <RBHText style={styles.pickReportHeader} data-testid={'pickReport-popup-header'} id={'pickReport-popup-header'}
            text={'main.report.pickReport.popup.header'} />
          <RBHText style={styles.pickReportDesc} data-testid={'pickReport-popup-desc'} id={'pickReport-popup-desc'}
            text={'main.report.pickReport.popup.desc'} />
          <RBHBox style={styles.line} />
          <Form form={form} onFinish={onFinishPickReport}>
            <Form.Item noStyle colon={false} name={'reportType'} required={true} initialValue={modal.merchantReportType} >
              <Radio.Group style={styles.pickReportRadioBox}>
                <RBHRadio value={1} data-testid={'radio-type1'} id={'radio-type1'} style={styles.reportType1}
                  textOption={'main.report.pickReport.popup.type1'} />
                <RBHText style={styles.typeDesc} data-testid={'type1-desc'} id={'type1-desc'}
                  text={'main.report.pickReport.popup.type1.desc'} />
                <RBHText style={styles.typeDesc} data-testid={'type1-desc2'} id={'type1-desc2'}
                  text={'main.report.pickReport.popup.type1.desc2'} />
                <RBHText style={styles.type1Desc3} data-testid={'type1-desc3'} id={'type1-desc3'}
                  text={'main.report.pickReport.popup.type1.desc3'} />

                <RBHRadio value={2} data-testid={'radio-type2'} id={'radio-type2'} style={styles.reportType2}
                  textOption={'main.report.pickReport.popup.type2'} />
                <RBHText style={styles.typeDesc} data-testid={'type2-desc'} id={'type2-desc'}
                  text={'main.report.pickReport.popup.type2.desc'} />
                <RBHText style={styles.typeDesc} data-testid={'type2-desc2'} id={'type2-desc2'}
                  text={'main.report.pickReport.popup.type2.desc2'} />
                <RBHText style={styles.type2Desc3} data-testid={'type2-desc3'} id={'type2-desc3'}
                  text={'main.report.pickReport.popup.type2.desc3'} />
              </Radio.Group>
            </Form.Item>
            <RBHBox style={styles.line} />
            <RBHText style={styles.remark} data-testid={'remark'} id={'remark'}
              text={'main.report.pickReport.popup.remark'}
              values={{
                batchReportStart: modal.batchReportStart,
                batchReportEnd: modal.batchReportEnd
              }} />
            <Row justify='end'>
              <Space size={metrics.baseMargin * 1.25}>
                <RBHButton id={'pickReport-cancelBtn'} data-testid={'pickReport-cancelBtn'} style={styleButton.buttonFromCancelGradient}
                  onClick={onCancelPickReport} text={'main.button_cancel'} />
                <RBHButton style={styleButton.buttonModalConfirmGradient} data-testid={'pickReport-saveBtn'} id={'pickReport-saveBtn'}
                  type='primary' htmlType='submit' disabled={modal.isBatchTimePeriod} text={'main.button_save'}>
                </RBHButton>
              </Space>
            </Row>
          </Form>
        </RBHBox>
      );
    } else if (modal.type === MODAL_TYPE.PRODUCT_LIMIT) {
      return (
        <RBHBox style={styles.productLimitBox}>
          <RBHBox style={commonStyle.paddingAll20}>
            <Row justify={'space-between'} align='middle'>
              <RBHText style={styles.productLimitHeader} data-testid={'productLimitPopupHeader'} id={'productLimitPopupHeader'}
                text={'main.mart.product.add.form.detail.modal.title'} />
              <RBHImage id={'closePopupBtn'} data-testid={'closeProductLimitBtn'} src={Images.close}
                style={{ width: '24px', cursor: 'pointer' }} onClick={onCancelproductLimit} />
            </Row>
          </RBHBox>
          <RBHBox style={styles.line} />
          <Form form={form} style={styleText.formText} onFinish={onFinishWeightSizeLimit} onFieldsChange={checkFormProductLimitInvalid}>
            <RBHBox style={commonStyle.paddingAll20}>
              <RBHText style={styles.piecesPerPackTitle} data-testid={'piecesPerPackOptionTitle'} id={'piecesPerPackOptionTitle'}
                text={'main.mart.product.add.form.detail.modal.piecesPerPack'}
              />
              <Form.Item noStyle colon={false} name={'piecesPerPackOption'} required={true}
                initialValue={modal?.piecesPerPackOption ? modal?.piecesPerPackOption === 1 ? 1 : 2 : 1}>
                <Radio.Group onChange={onChangePiecesPerPackRadio}>
                  <RBHRadio value={1} data-testid={'piecesPerPackOption1'} id={'piecesPerPackOption1'} style={styles.productLimitOption}
                    textOption={'main.mart.product.add.form.detail.modal.piecesPerPack.option1'}
                  />
                  <Row>
                    <RBHRadio value={2} data-testid={'piecesPerPackOption2'} id={'piecesPerPackOption2'} style={styles.productLimitOption}
                      textOption={'main.mart.product.add.form.detail.modal.piecesPerPack.option2'}
                    />
                  </Row>
                  {piecesPerPackRadioValue === 2 ?
                    <RBHBox style={{ ...commonStyle.paddingLeftLarge }}>
                      <Form.Item name={'piecesPerPackOption2Input'} colon={false} validateTrigger={['onChange', 'onBlur']} required={true}
                        rules={[{
                          required: true,
                          message: <FormattedMessage id={'main.mart.product.add.form.detail.modal.piecesPerPack.option2.required'} />
                        }]}
                        initialValue={modal?.piecesPerPackOption !== 1 ? modal?.piecesPerPackOption : undefined}>
                        <RBHTextInput
                          onBlur={() => {
                            clearDecimal('piecesPerPackOption2Input');
                          }}
                          autoComplete={'off'}
                          style={styles.piecesPerPackOption2Input}
                          id={'piecesPerPackOption2Input'}
                          data-testid={'piecesPerPackOption2Input'}
                          placeholder={'main.mart.product.add.form.detail.modal.piecesPerPack.option2.placeholder'}
                        />
                      </Form.Item>
                    </RBHBox> : null
                  }
                </Radio.Group>
              </Form.Item>

              <RBHText style={styles.productLimitTitle} data-testid={'weightSizeLimitOptionTitle'} id={'weightSizeLimitOptionTitle'}
                text={'main.mart.product.add.form.detail.modal.weightSizeLimit'}
              />
              <Form.Item className={'weightLimitInput'} noStyle colon={false} name={'weightSizeLimitOption'}
                initialValue={!!modal?.weightLimitSelect ? 1 : !!modal?.sizeLimitSelect ? 2 : 1}>
                <Radio.Group onChange={onChangeWeightSizeLimitRadio}>
                  <RBHRadio value={1} data-testid={'sizeLimitOption1'} id={'sizeLimitOption1'} style={styles.productLimitOption}
                    textOption={'main.mart.product.add.form.detail.modal.weightSizeLimit.option1'}
                  />
                  {weightSizeLimitRadioValue === 1 &&
                    <RBHBox style={{ ...commonStyle.paddingLeftLarge }}>
                      <Form.Item name={'weightLimitOption1Input'} colon={false} validateTrigger={['onChange', 'onBlur']}
                        rules={[{
                          required: true,
                          message: <FormattedMessage id={'main.mart.product.add.form.detail.modal.weightSizeLimit.option1.required'} />
                        }]}
                        initialValue={modal?.weightLimitOption1Input ? modal?.weightLimitOption1Input : undefined}>
                        <RBHTextInput
                          onBlur={() => {
                            clearDecimal('weightLimitOption1Input');
                          }}
                          className={'weightLimitInput'}
                          autoComplete={'off'}
                          style={styles.weightSizeLimit}
                          id={'weightLimitInput'}
                          data-testid={'weightLimitInput'}
                          addonAfter={getSelectWeightLimit()}
                          placeholder={'main.mart.product.add.form.detail.modal.weightSizeLimit.sizeLimit.placeholder'}
                        />
                      </Form.Item>
                    </RBHBox>
                  }
                  <Row>
                    <RBHRadio value={2} data-testid={'sizeLimitOption2'} id={'sizeLimitOption2'} style={styles.productLimitOption}
                      textOption={'main.mart.product.add.form.detail.modal.sizeLimit.option2'}
                    />
                  </Row>
                  {weightSizeLimitRadioValue === 2 &&
                    <RBHBox style={styles.sizeLimitBox}>
                      <Form.Item noStyle name={'sizeLimitSelect'} colon={false} validateTrigger={['onChange', 'onBlur']}
                        initialValue={modal?.sizeLimitId ? modal?.sizeLimitId : 1}>
                        <RBHSelect
                          id={'sizeLimitSelect'}
                          data-testid={'sizeLimitSelect'}
                          style={styles.sizeLimit}
                          defaultActiveFirstOption={true}
                        >
                          {selectproductSize()}
                        </RBHSelect>
                      </Form.Item>
                    </RBHBox>
                  }
                </Radio.Group>
              </Form.Item>
            </RBHBox>
            <RBHBox style={styles.line} />
            <Row justify={'end'}>
              <Space size={metrics.baseMargin} style={commonStyle.paddingAll20}>
                <RBHButton style={styleButton.buttonFromCancelGradient} data-testid={'productLimitCancelBtn'} id={'productLimitCancelBtn'}
                  onClick={onCancelproductLimit} text={'main.button_cancel'} />
                <RBHButton style={styleButton.buttonModalConfirmGradient} data-testid={'productLimitSaveBtn'} id={'productLimitSaveBtn'}
                  type={'primary'} htmlType={'submit'} disabled={formInvalid} text={'main.button_save'}>
                </RBHButton>
              </Space>
            </Row>
          </Form >
        </RBHBox >
      );
    } else if (modal.type === MODAL_TYPE.DELETE_DISCOUNT) {
      return (
        <RBHBox style={styles.deleteDiscount}>
          <Row style={styleText.textModalHeader} align={'middle'}>
            <WarningFilled style={{...styleText.textModalHeader, color: '#FEBD34', marginRight: 12}} translate={null}/>
            <RBHText style={styleText.textModalHeader} id={'deleteTitle'} text={modal.modalTitle ||'main.foodmenu.deletemenu.userAction.title'} />
          </Row>
          <br />
          <Row>
            <RBHText style={styleText.textModalContent} id={'deleteContent'} text={modal.modalContent || 'main.foodmenu.deletemenu.userAction.content'} />
          </Row>
          <Divider style={{margin: '24px -16px 16px -16px', width: 'auto'}} />
          <Row justify='end' align='middle'>
            <Space size={'small'}>
              <RBHButton style={styleButton.buttonModalCancelGradient} data-testid={'button_cancel'}
                id={'button_cancel'} key='back' onClick={modal.onCancel}>
                <FormattedMessage id={'main.button_cancel'} />
              </RBHButton>
              <RBHButton style={styleButton.buttonModalConfirmGradient} data-testid={'button_confirm'}
                id={'button_confirm'} key='submit' type='primary' onClick={modal.onOk}>
                <FormattedMessage id={'main.button_confirm'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      )
    } else if (modal.type === MODAL_TYPE.LIST_SORT_FORM) {
      return (
        <RBHBox style={styles.sortListForm}>
          <Row style={styleText.textModalHeader} align={'middle'}>
            <RBHText style={styleText.textModalHeader} text={modal.modalTitle ||'main.foodmenu.deletemenu.userAction.title'} />
          </Row>
          <br />
          {modal.modalContent}
          <Divider style={{margin: '24px -16px 16px -16px', width: 'auto'}} />
          <Row justify='end' align='middle'>
            <Space size={'small'}>
              <RBHButton style={styleButton.buttonModalCancel} data-testid={'button_cancel'}
                id={'button_cancel'} key='back' onClick={modal.onCancel}>
                <FormattedMessage id={'main.button_cancel'} />
              </RBHButton>
              <RBHButton style={styleButton.buttonSave} data-testid={'button_confirm'}
                id={'button_confirm'} key='submit' type='primary' onClick={modal.onOk}>
                <FormattedMessage id={'main.button_save'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      )
    } else {
      return null;
    }
  };

  return (
    <Modal
      destroyOnClose={true}
      afterClose={() => onAfterClose()}
      maskClosable={modal.clickClosable}
      keyboard={modal.escClosable}
      closable={false}
      visible={modal.visible}
      onCancel={onCancel}
      centered={true}
      footer={null}>
      {showModal()}
    </Modal>
  );
};

export default RBHModal;
